import { StyleSheet } from 'react-native';
import { TextSmallSize, TextdefaultSize } from '../../../common/constants/Fonts';

export const addressModalStyle = StyleSheet.create({
  label: {
    color: '#555',
    fontSize: TextSmallSize,
  },
  input: {
    borderColor: 'gray',
    borderWidth: 1,
    marginTop: 4,
    marginBottom: 10,
    padding: 10,
    paddingHorizontal: 8,
  },
  inputDisable: {
    borderColor: '#ddd',
  },
  select: {
    height: 40,
    borderColor: 'gray',
    borderWidth: 1,
    marginTop: 4,
    marginBottom: 10,
    padding: 8,
  },
  addButton: {
    backgroundColor: '#2e96e1',
    color: 'white',
    paddingVertical: 8,
    paddingHorizontal: 12,
    textAlign: 'center',
    borderRadius: 5,
    marginLeft:10,
    borderWidth:2, 
    borderColor:'#2e96e1',
  },
  message: {
    width: '100%',
    color: 'red',
    marginBottom: 0,
    marginTop: -10,
    fontSize: TextSmallSize,
    paddingLeft: 5,
  },
  overlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
  textarea: {
    height: TextdefaultSize * 6,
  },
  outLineButton: {
    alignItems: 'center',
    justifyContent:'center',
    paddingVertical: 6,
    paddingHorizontal: 20,
    borderRadius: 5,
    borderWidth: 2,
    borderColor: '#6c757d',
    marginLeft: 13,
    // fontFamily: 'san'
  },
  outlineBtnText: {
    fontSize: 14,
    letterSpacing: 1,
    textAlign: 'center',
    // color:'#6c757d',
    // marginLeft: 10,
  },
  footerContainer: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  subtitle: {
    fontSize: 14,
    color: '#666',
    marginBottom: 8,
    lineHeight: 20,
  },
  radioContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 4,
    paddingHorizontal: 4,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  radioButton: {
    height: 20,
    width: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#4379FF',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  radioButtonInner: {
    height: 10,
    width: 10,
    borderRadius: 5,
    backgroundColor: '#4379FF',
  },
  radioIcon: {
    marginRight: 12,
    width: 20,
    textAlign: 'center',
  },
  radioLabel: {
    fontSize: 16,
    color: '#333',
    fontWeight: '400',
  },
  radioLabelSelected: {
    color: '#4379FF',
    fontWeight: '500',
  }
});
